export interface InfoTextProps {
  readonly text: string;
  readonly type: InfoTextType;
}

export enum InfoTextType {
  Default = 'default',
  Footnote = 'footnote',
}
